import { Injectable } from '@angular/core';
import {
    FavoriteAicraftData,
} from 'src/app/models/flight-watch';
import { FavoriteStrategy } from './favorite.strategy';
import { FavoritesService } from 'src/app/services/favorites.service';
import { SharedService } from 'src/app/layouts/shared-service';
import { SnackBarService } from 'src/app/ui-services/snackbar/snackBar.service';

@Injectable({
    providedIn: 'root',
})
export class CompanyFavorite implements FavoriteStrategy {

    public constructor(
        private snackbarService: SnackBarService,
        private favoritesService: FavoritesService,
        private sharedService: SharedService
    ) {}
    public getIsFavoriteDefaultValue(favoriteData: any): boolean {
        return favoriteData?.favoriteCompany != null;  
    }
    public async toogleFavorite(
        favoriteData: FavoriteAicraftData
    ): Promise<FavoriteAicraftData> {
        return await this.companyFavoriteClickAction(favoriteData);
    }
    private async companyFavoriteClickAction(favoriteData: any): Promise<FavoriteAicraftData> {
        if(favoriteData.isFavorite){
            let result =  await this.favoritesService.saveCompanyFavorite(this.sharedService.currentUser.fboId, favoriteData.customerInfoByGroupId).toPromise();
    
            if(result){
                favoriteData.favoriteCompany = result;
            }
            else{
                this.snackbarService.showErrorSnackBar("Error adding company to favorites");
                favoriteData.favoriteCompany = null;
                favoriteData.isFavorite = false;
            }
            return favoriteData;
        }
            
        let result = await this.favoritesService.deleteCompanyFavorite(favoriteData.favoriteCompany.oid).toPromise();
        if(result){
            favoriteData.favoriteCompany = null;
        }
        else{
            this.snackbarService.showErrorSnackBar("Error removing company from favorites");
            favoriteData.isFavorite = true;
        }
    }
}